import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function CardCursos(props) {
  return (
    <div className="w-full rounded-lg rounded-tl-none bg-secundario relative overflow-hidden group ">
      <div className="h-[250px] sm:h-[225px] md:h-[250px] xl:h-[280px] rounded-lg rounded-tl-none overflow-hidden">
        <img
          src={props.img}
          alt={props.descripcion}
          className="object-cover object-center w-full h-full group-hover:motion-safe:scale-110 group-hover:rotate-1 transition-all duration-300 ease-in-out "
        />
      </div>
      <div className="flex flex-col justify-start text-left p-3 sm:p-4 md:p-4 xl:p-5 text-white gap-2 w-full lg:h-[320px] xl:h-[280px]">
        <h3 className=" font-bold self-start text-blue-4 text-lg md:text-lg lg:text-xl 2xl:text-2xl">
          {props.curso}
        </h3>
        <p className=" text-base text-black hyphens-none">{props.descripcion}</p>
        {props.url ? (
          <Link
            to={props.url}
            className="text-sm md:text-base self-end mt-auto place-items-end px-4 py-2 bg-primario rounded-lg rounded-tr-none text-white hover:bg-blue-1 transition-all duration-300 ease-in-out"
          >
            {" "}
            Ver más
          </Link>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default CardCursos;
